<template>
  <div class="home">
    <v-container class="justify center text-center" style="max-width:1100px;">
      <p>
        Unsere kleine Werbeagentur, die im oberbayerischen Mauern ansässig ist,
        entstand im Jahre 1994. Zu diesem Zeitpunkt haben wir von einem
        Bekannten der Familie die Firma übernommen und sind damit zuverlässiger
        und kompetenter Partner, vor allem für Firmen und Unternehmen in der
        nahen Umgebung. Unser Portfolio umfasst die Fahrzeug- und
        Werbebeschriftung, den Textildruck und zahlreiche weitere Werbemittel
        (u. a. auch Aufkleber und Etiketten), die wir Ihnen vollumfänglich von
        der Designentwicklung bis zur Umsetzung vor Ort anbieten.
      </p>
      <p>
        Wir erstellen Ihnen gerne ein individuelles Angebot, dass ihren
        Ansprüchen und Budget gerecht wird. Sprechen Sie uns telefonisch oder
        per E-Mail an. Wir freuen uns auf Ihre Anfrage und eine potenzielle
        Zusammenarbeit!
      </p>
    </v-container>

    <v-card class="d-flex flex-wrap justify-center" flat color="transparent">
      <!-- Card 1 -->
      <v-hover v-slot:default="{ hover }" open-delay="200">
        <v-card
          :class="cardClass"
          :max-width="cardMaxWidth"
          :min-width="cardMinWidth"
          @click="overlayCard1 = true"
          :elevation="hover ? 20 : 2"
        >
          <v-img src="../assets/card_1.jpg" class="white--text align-center">
            <v-overlay :opacity="hover ? 0.1 : 0.4" absolute>
              <v-card-title class="d-flex justify-center text-center">
                Fahrzeug- und Werbebeschriftung
              </v-card-title>

              <v-card-text
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                Klicken Sie, um mehr zu erfahren
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                <v-icon large color="white"
                  >mdi-chevron-double-down fa-spin</v-icon
                >
              </v-card-actions>
            </v-overlay>
          </v-img>
        </v-card>
      </v-hover>

      <!-- <v-overlay :value="overlayCard1" opacity="0.4"> -->
      <v-dialog v-model="overlayCard1" scrollable max-width="1100px">
        <v-card light style="opacity:0.99;">
          <v-card-title class="justify-center text-center"
            >Fahrzeug- und Werbebeschriftung</v-card-title
          >

          <v-divider class="py-2"></v-divider>

          <v-card-text>
            <p>
              Sehr viele Unternehmen und Firmen verfügen über einen Fuhrpark,
              der sich ideal als mobile Werbefläche eignet und
              öffentlichkeitswirksam genutzt werden kann. Unser Werbeshop 601
              bietet neben der Erstellung des individuellen, auf Sie
              zugeschnittenen Designs
              <strong
                >professionelle Folienbeschriftungen, Teilverklebungen oder
                Folierungen</strong
              >
              für ihren Transporter, Anhänger oder Firmenfahrzeug, abgestimmt
              auf ihr Corporate Design, an.
            </p>
            <p>
              Für jedes Fahrzeug und Budget fertigen wir Ihre
              Fahrzeugbeschriftungen, unabhängig ob Sie eine aufwändige
              Beschriftung wünschen oder ein dezentes Design bevorzugen. Wir
              fertigen Ihnen einen Grafikentwurf an, so können Sie vorab sehen,
              wie die geplante Werbung an ihrem Fahrzeug wirkt.
            </p>
            <p>
              Unsere Beschriftungen sind je nach Einsatzzwecks leicht ablösbar
              oder auch robust und beständig gegen Witterungseinflüsse,
              Waschstraße etc. – Wir fertigen zudem auch Magnetschilder, die z.
              B. für temporäre Fahrzeugbeschriftungen oder bei
              Promotionen-Aktionen zum Einsatz kommen können.
            </p>
            <p>
              Eine weitere Möglichkeit bietet Ihnen der Einsatz von Außenwerbung
              in Form von u. a. Aufstellern, Planen oder Werbetafeln zum Zwecke
              der Außenwerbung, Weitenwirkungen oder zum Auffinden ihres
              Betriebs.
            </p>
            <p>
              Wir sind ihr kompetenter Partner für
              <span>
                <ul>
                  <li>
                    <strong>Beschilderung</strong> (u. a. Türschilder,
                    Wegeleitsystem, Firmen- und Praxenschilder, Bauschilder,
                    Aufsteller),
                  </li>
                  <li>
                    <strong>Digitaldruck</strong> (u. a. für Aufkleber,
                    Messestände, Banner, Magnetschilder, Planen),
                  </li>

                  <li>
                    <strong>Fensterbeschriftung</strong> (u. a.
                    Folienbeschriftung, Sichtschutzfolien) und
                  </li>
                  <li>unserem <strong>Montageservice</strong>.</li>
                </ul>
              </span>
            </p>

            <p>
              Wir achten bei allen Produkten auf hochwertige Materialien und
              garantieren Ihnen eine einwandfreie Verarbeitung.
            </p>

            <v-row class="d-flex flex-row justify-center">
              <v-col class="d-flex flex-column pa-1">
                <v-img
                  src="../assets/card_1/card_1_ref_1.jpg"
                  class="d-flex flex-column"
                  max-width="330"
                  max-height="630"
                ></v-img>
              </v-col>
              <v-col class="d-flex flex-column pa-1">
                <v-img
                  src="../assets/card_1/card_1_ref_2.jpg"
                  class="d-flex flex-column"
                  max-width="330"
                  max-height="630"
                ></v-img>
              </v-col>
              <v-col class="d-flex flex-column pa-1">
                <v-img
                  src="../assets/card_1/card_1_ref_3.jpg"
                  class="d-flex flex-column"
                  max-width="330"
                  max-height="630"
                ></v-img>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider class="py-2"></v-divider>

          <v-card-actions class="justify-center">
            <v-btn tile outlined @click="overlayCard1 = false">
              <v-icon>mdi-close</v-icon>
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-overlay> -->

      <!-- Card 2 -->
      <v-hover v-slot:default="{ hover }" open-delay="200">
        <v-card
          :class="cardClass"
          :max-width="cardMaxWidth"
          :min-width="cardMinWidth"
          @click="overlayCard2 = true"
          :elevation="hover ? 20 : 2"
        >
          <v-img src="../assets/card_2.jpg" class="white--text align-center">
            <v-overlay :opacity="hover ? 0.1 : 0.4" absolute>
              <v-card-title class="d-flex justify-center text-center">
                Textildruck
              </v-card-title>

              <v-card-text
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                Klicken Sie, um mehr zu erfahren
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                <v-icon large color="white">mdi-chevron-double-down</v-icon>
              </v-card-actions>
            </v-overlay>
          </v-img>
        </v-card>
      </v-hover>
    </v-card>

    <!-- <v-overlay :value="overlayCard2" opacity="0.4" z-index="5"> -->
    <v-dialog v-model="overlayCard2" scrollable max-width="1100px">
      <v-card light style="opacity:0.99;">
        <v-card-title class="justify-center text-center"
          >Textildruck</v-card-title
        >

        <v-divider class="py-2"></v-divider>

        <v-card-text>
          <p>
            Im alltäglichen Leben, der unmittelbaren Begegnung, ob direkt am
            Arbeitsplatz oder auf der Straße. Das Werbemittel, das einfach da
            ist – die Bekleidung! Egal, ob T-Shirts, Jacken, Polo-Shirts oder
            auch Mützen, ob für das Unternehmen oder den örtlichen Verein –
            dieses Werbemittel wirkt und ist im Trend! Egal, ob für Sport,
            Freizeit oder Beruf – wir veredeln Ihre Textilieren mit Flex- oder
            Flockfolie.
          </p>
          <p>
            Wir finden
            <span>
              <ul>
                <li>
                  den passenden <strong>Merchandise-Artikel</strong> für ihren
                  Verein oder Band
                </li>
                <li>
                  die richtige <strong>Arbeitskleidung</strong> für ihre
                  Mitarbeiter und ihr Unternehmen
                </li>
                <li>
                  auch <strong>Fun- und Freizeit-Artikel</strong> für den
                  Turnbeutel, den Junggesellenabschied, Schulabschluss- bzw.
                  Abi-T-Shirts oder den Ausflug mit Freunden.
                </li>
              </ul>
            </span>
          </p>
          <p>
            Wir gestalten für Sie in kleinen Mengen oder auch größeren
            Stückzahlen im Bereich des Textildruckes für u. a. T-Shirts und
            Polo-Shirts; Hemden, Blusen und Jacken; Sweatshirts etc. – Sprechen
            Sie uns gerne an!
          </p>
          <p>
            Natürlich achten wir auf hochwertige Materialen mit einen
            ausgezeichneten Waschbeständigkeit, um Ihnen lange Freude zu
            bereiten.
          </p>

          <v-row class="d-flex flex-row justify-center">
            <v-col class="d-flex flex-column pa-1">
              <v-img
                src="../assets/card_2/card_2_ref_1.jpg"
                class="d-flex flex-column"
                max-width="330"
                max-height="460"
              ></v-img>
            </v-col>
            <v-col class="d-flex flex-column pa-1">
              <v-img
                src="../assets/card_2/card_2_ref_2.jpg"
                class="d-flex flex-column"
                max-width="330"
                max-height="460"
              ></v-img>
            </v-col>

            <v-col class="d-flex flex-column pa-1">
              <v-img
                src="../assets/card_2/card_2_ref_3.jpg"
                class="d-flex flex-column"
                max-width="330"
                max-height="460"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="py-2"></v-divider>

        <v-card-actions class="justify-center">
          <v-btn tile outlined @click="overlayCard2 = false">
            <v-icon>mdi-close</v-icon>
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- </v-overlay> -->

    <v-card class="d-flex flex-wrap justify-center" flat color="transparent">
      <!-- Card 3 -->
      <v-hover v-slot:default="{ hover }" open-delay="200">
        <v-card
          :class="cardClass"
          :max-width="cardMaxWidth"
          :min-width="cardMinWidth"
          @click="overlayCard3 = true"
          :elevation="hover ? 20 : 2"
        >
          <v-img src="../assets/card_3.jpg" class="white--text align-center">
            <v-overlay :opacity="hover ? 0.1 : 0.4" absolute>
              <v-card-title class="d-flex justify-center text-center">
                Werbemittel
              </v-card-title>

              <v-card-text
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                Klicken Sie, um mehr zu erfahren
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                <v-icon large color="white">mdi-chevron-double-down</v-icon>
              </v-card-actions>
            </v-overlay>
          </v-img>
        </v-card>
      </v-hover>

      <!-- <v-overlay :value="overlayCard3" opacity="0.4" z-index="5"> -->
      <v-dialog v-model="overlayCard3" scrollable max-width="1100px">
        <v-card light style="opacity:0.99;">
          <v-card-title class="justify-center text-center"
            >Werbemittel</v-card-title
          >

          <v-divider class="py-2"></v-divider>

          <v-card-text>
            <p>
              Unser Portfolio beinhaltet noch weitere Medien, die wir Ihnen kurz
              vorstellen möchten:
            </p>
            <p>
              <span>
                <ul>
                  <li class="py-2">
                    <strong>Etiketten:</strong> Die Werbewirkung ist ebenso
                    einfach wie originell, da Etiketten sich schnell und
                    effektiv an diversen Objekten anbringen lassen. Durch
                    individuelle Gestaltungs- und Layoutmöglichkeiten entwerfen
                    wir mit Ihnen zusammen ein abgestimmtes Design und sind
                    verlässlicher Partner für den unkomplizierten Druckservice.
                  </li>
                  <li class="py-2">
                    <strong>Aufkleber:</strong> Folien und Aufkleber lassen sich
                    von allen Werbemedien am individuellsten gestalten. Es gibt
                    sie in allen Formen, Größen und Farben und sie können für
                    fast alle Zwecke eingesetzt werden. Vom kleinen Aufkleber
                    für das Fahrzeug bis zum Bekleben eines Aufzugs sind Ihnen
                    kaum Grenzen gesetzt. Wir beraten Sie gerne!
                  </li>
                  <li class="py-2">
                    <strong>Wandtattoos:</strong> Lernen Sie die kreative und
                    individuelle Gestaltung für ihre Innenräume kennen, die sich
                    für alle Räume in z. B. Arztpraxen, Gastgewerbe oder auch
                    für die privaten Räumlichkeiten anwenden lässt. Wir
                    garantieren ebenfalls eine rückstandslose Entfernung.
                  </li>
                  <li class="py-2">
                    <strong>Plakate:</strong> Sie planen eine Veranstaltung und
                    möchten Werbemittel drucken (lassen)? Auch hier sind wir ihr
                    kompetenter Partner und bieten Ihnen diesen Service gerne
                    an.
                  </li>
                  <li class="py-2">
                    <strong>Visitenkarten:</strong> Der Klassiker, um seine
                    Kontaktdaten stilecht zu übergeben – natürlich können wir
                    auch dies abdecken, um Ihnen einen prägenden Ersteindruck zu
                    ermöglichen.
                  </li>
                </ul>
              </span>
            </p>
            <p>
              Und natürlich umfasst unser Angebot auch
              <strong>Stempel, Broschüren, Kalender, usw.</strong> – eben alle
              Werbemittel und -technik, die Unternehmen und Firmen für Werbe-
              und Marketingzwecke einsetzen können.
            </p>
            <p>
              Sie haben noch nicht das Passende gefunden? Bitte sprechen Sie uns
              gerne telefonisch oder per E-Mail an, sodass wir Ihnen unsere
              verlässlichen und kompetenten Dienste unserer Werbeagentur
              anbieten dürfen.
            </p>

            <v-row class="d-flex flex-row justify-center">
              <v-col class="d-flex flex-column pa-1">
                <v-img
                  src="../assets/card_3/card_3_ref_1.jpg"
                  class="d-flex flex-column"
                  max-width="330"
                  max-height="270"
                ></v-img>
              </v-col>

              <v-col class="d-flex flex-column pa-1">
                <v-img
                  src="../assets/card_3/card_3_ref_2.jpg"
                  class="d-flex flex-column"
                  max-width="660"
                  max-height="270"
                ></v-img>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider class="py-2"></v-divider>

          <v-card-actions class="justify-center">
            <v-btn tile outlined @click="overlayCard3 = false">
              <v-icon>mdi-close</v-icon>
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- </v-overlay> -->

      <!-- Card 4 -->
      <v-hover v-slot:default="{ hover }" open-delay="200">
        <v-card
          :class="cardClass"
          :max-width="cardMaxWidth"
          :min-width="cardMinWidth"
          href="https://w601shop.de"
          target="_blank"
          :elevation="hover ? 20 : 2"
        >
          <v-img src="../assets/card_4.jpg" class="white--text align-center">
            <v-overlay :opacity="hover ? 0.1 : 0.4" absolute>
              <v-card-title class="d-flex justify-center text-center">
                Shop
              </v-card-title>

              <v-card-text
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                Schauen Sie in unserem Webshop vorbei
              </v-card-text>
              <v-card-actions
                class="d-flex justify-center"
                v-if="hover || $vuetify.breakpoint.xsOnly"
              >
                <v-icon large color="white">mdi-chevron-double-down</v-icon>
              </v-card-actions>
            </v-overlay>
          </v-img>
        </v-card>
      </v-hover>
    </v-card>

    <v-spacer class="my-8"></v-spacer>

    <!-- <v-card
      class="d-flex flex-wrap justify-center"
      flat
      tile
      color="transparent"
    > -->
    <v-card class="my-9" flat color="transparent">
      <h3 class="display-1 font-weight-light text-center">
        Kontakt
      </h3>

      <!-- <p class="text-center">
        <span> - </span>So erreichen Sie uns<span> - </span>
      </p> -->

      <v-container class="d-flex justify-center">
        <v-col cols="9">
          <v-row class="justify-center">
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-card
                :class="contactCard"
                style="min-width:220px;"
                href="https://goo.gl/maps/D8MsuGPjzLLiMG3S9"
                target="_blank"
                :elevation="hover ? 20 : 2"
              >
                <div>
                  <v-icon x-large class="mx-2">mdi-map-marker</v-icon>
                </div>

                <div class="text-uppercase title mt-2">
                  Adresse
                </div>

                <v-divider class="my-2"></v-divider>

                <div>
                  Werbeshop 601<br />
                  Prälat-Dr.-Hartig-Straße 5<br />
                  85419 Mauern
                </div>
              </v-card>
            </v-hover>
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-card
                :class="contactCard"
                style="min-width:220px;"
                href="mailto:info@w601.de"
                :elevation="hover ? 20 : 2"
              >
                <div>
                  <v-icon x-large class="mx-2">mdi-email</v-icon>
                </div>

                <div class="text-uppercase title mt-2">
                  E-Mail
                </div>

                <v-divider class="my-2"></v-divider>

                <div>
                  info@w601.de
                </div>
              </v-card>
            </v-hover>
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-card
                :class="contactCard"
                style="min-width:220px;"
                href="tel:+4987648695"
                :elevation="hover ? 20 : 2"
              >
                <div>
                  <v-icon x-large class="mx-2">mdi-phone</v-icon>
                </div>

                <div class="text-uppercase title mt-2">
                  Telefon
                </div>
                <v-divider class="my-2"></v-divider>
                <div>
                  +49 8764 8695
                </div>
              </v-card>
            </v-hover>
            <v-hover v-slot:default="{ hover }" open-delay="200">
              <v-card
                :class="contactCard"
                style="min-width:220px;"
                href="tel:+4915253569177"
                :elevation="hover ? 20 : 2"
              >
                <div>
                  <v-icon x-large class="mx-2">mdi-cellphone</v-icon>
                </div>

                <div class="text-uppercase title mt-2">
                  Mobile
                </div>
                <v-divider class="my-2"></v-divider>
                <div>
                  +49 152 53569177
                </div>
              </v-card>
            </v-hover>
          </v-row>
        </v-col>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data: () => ({
    overlayCard1: false,
    overlayCard2: false,
    overlayCard3: false,
    cardMaxWidth: 480,
    cardMinWidth: 200,
    cardClass: "pa-0 ma-3 rounded-card",
    contactCard: "ma-3 pa-3 text-center",
    contactCardHover: "ma-5 pa-4 text-center",
    carouselItems1: [
      { src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg" },
      { src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg" },
      { src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg" }
    ]
  })
};
</script>
<style scoped>
.rounded-card {
  border-radius: 50px;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}
</style>
